/**
 * FZ-FIX F10 (the 142nd; his word in the 141st: "Switch all three now") - the street basemap every app map draws.
 * CARTO's basemap answers EVERY tile with an "API KEY REQUIRED" picture (2,049 bytes, measured again 2026-10-15), so
 * the property page, Prospecting and Land Upside maps drew their pins on a blank. Esri's World Street Map - the client
 * portal's - answers real tiles with no key. Drawn natively to zoom 19 and stretched to 20 (Prospecting allows 20).
 * `src/mapTiles.guard.test.ts` keeps a CARTO tile address from coming back.
 */
export const STREET_TILES = {
  url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
  attribution: 'Tiles &copy; Esri',
  maxNativeZoom: 19,
  maxZoom: 20,
} as const;
